import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, CircularProgress, Typography } from '@mui/material';

export const APPROVAL_REDIRECT_KEY = 'workflow_approval_returnTo';

const WorkflowApprovalRedirect = () => {
  const { token } = useParams<{ token: string }>();
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading || !token) return;

    let destination: string;

    try {
      const decoded = JSON.parse(atob(token));
      const { task_id, action } = decoded;
      if (!task_id || !action) throw new Error('Invalid token payload');
      destination = `/approval-tasks/${task_id}?action=${encodeURIComponent(action)}`;
    } catch {
      navigate('/not-found', { replace: true });
      return;
    }

    if (isAuthenticated) {
      navigate(destination, { replace: true });
    } else {
      // Persist destination so AppContent can redirect after login completes
      sessionStorage.setItem(APPROVAL_REDIRECT_KEY, destination);
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, token, navigate, loginWithRedirect]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <CircularProgress size={30} sx={{ mb: 1 }} />
      <Typography variant="body1" color="text.secondary">Redirecting...</Typography>
    </Box>
  );
};

export default WorkflowApprovalRedirect;
